import React from "react";
import './styles.css';



  


function Navhovcom(){

    return (
        <>
            <li>
                <span className="link">
                    <span className="word">
                        <span className="char" data-char="c" style={{"--charIndex": 0 }}>c</span>
                        <span className="char" data-char="o" style={{"--charIndex": 1 }}>o</span>
                        <span className="char" data-char="m" style={{"--charIndex": 2 }}>m</span>
                        <span className="char" data-char="m" style={{"--charIndex": 3 }}>m</span>
                        <span className="char" data-char="i" style={{"--charIndex": 4 }}>i</span>
                        <span className="char" data-char="s" style={{"--charIndex": 5 }}>s</span>
                        <span className="char" data-char="s" style={{"--charIndex": 6 }}>s</span>
                        <span className="char" data-char="i" style={{"--charIndex": 7 }}>i</span>
                        <span className="char" data-char="o" style={{"--charIndex": 8 }}>o</span>
                        <span className="char" data-char="n" style={{"--charIndex": 9 }}>n</span>
                    </span>
                </span>
                    
            </li>
        </>
        
    )
}

export default Navhovcom;